import { useEffect, useState } from 'react';
import { useApi } from './useApi';

/** Read state belongs to this path; a failed request is never an empty success. */
export function useWarehouseRead<T>(path: string) {
  const { fetchApi, error } = useApi(); const [reload, setReload] = useState(0);
  const [state, setState] = useState<{ path: string; data: T | null; loading: boolean; failed: boolean }>({ path, data: null, loading: true, failed: false });
  useEffect(() => {
    let active = true; const controller = new AbortController();
    setState({ path, data: null, loading: true, failed: false });
    void fetchApi<T>(path, { signal: controller.signal, cache: 'no-store' }).then(data => {
      if (active) setState({ path, data, loading: false, failed: data === null });
    });
    return () => { active = false; controller.abort(); };
  }, [path, reload, fetchApi]);
  const current = state.path === path ? state : { data: null, loading: true, failed: false };
  return { ...current, error: current.failed ? error || 'This work could not be loaded. Try again.' : '', refresh: () => setReload(value => value + 1) };
}
